import * as React from 'react'
import { withRouter } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import styled from 'styled-components'
import { StoreProps } from 'src/stores'
import { ConfiguratorBox } from 'src/components/containers/configurator/ConfiguratorBox'
import { FormCheckbox } from 'src/components/atoms/input/FormCheckbox'
import Link from 'src/components/atoms/input/buttons/Link'
import { RadioButton, RadioGroup } from 'src/components/atoms/input/RadioButton'
import { FuneralType } from 'src/resources'
import FeedbackText from 'src/components/atoms/FeedbackText'

const NumberFormat = require('react-number-format')

const heartIcon = require('src/assets/redesign/betreuung_icon_2.png')
const priceIcon = require('src/assets/redesign/preise_icon.png')
const checkIcon = require('src/assets/redesign/organisation_icon.png')

interface Props extends StoreProps {
  location: any
  history: any
  match: any
}

@inject('confStore')
@observer
export class Order extends React.Component<Props, any> {
  constructor(props) {
    super(props)
    this.state = {
      checked1: false,
      checked2: false,
      checked3: false,
      checked4: false,
      payment: 'ON_APPROVAL',
      errorMessage: ''
    }
  }

  stringifyFuneralType = (ft: FuneralType) => {
    switch (ft) {
      case 'BURIAL':
        return 'Erbestattung'
      case 'CREMATION':
        return 'Feuerbestattung'
      case 'TREE_FUNERAL':
        return 'Baumbestattung'
      case 'SEA_FUNERAL':
        return 'Donaubestattung'
      default:
        return 'ERROR'
    }
  }

  handleCheck = (id, checked) => {
    const { checked1, checked2, checked3, checked4 } = this.state
    const tempState = {
      checked1,
      checked2,
      checked3,
      checked4
    }
    tempState[id] = checked
    this.setState(tempState)
  }

  setPayment = (key) => {
    this.setState({ payment: key })
  }

  submit = () => {
    const { history, confStore } = this.props
    const offer = confStore.getOffer
    confStore
      .confirmOrder()
      .then((status) => {
        if (status) {
          history.push(`/planung/bestaetigung/${offer.uuid}`)
        } else {
          this.setState({
            errorMessage:
              'Ups ... das hat nicht funktioniert. Bitte probieren Sie es nochmal.'
          })
        }
      })
      .catch((r) => {
        console.error(r)
        this.setState({
          errorMessage:
            'Ups ... das hat nicht funktioniert. Bitte probieren Sie es nochmal.'
        })
      })
  }

  render() {
    const { confStore } = this.props
    const { checked1, checked2, checked3, checked4, errorMessage } = this.state

    const offer = confStore.getOffer
    const greeting =
      offer.contactDetails.greeting === 'MR'
        ? 'Sehr geehrter Herr '
        : 'Sehr geehrte Frau '
    const totalNoDiscount = confStore.offerProductTotalWithDiscounts()

    return (
      <ConfiguratorBox title='Angebot annehmen'>
        <p>
          {greeting}
          {offer.contactDetails.lastName},
        </p>
        <p>
          Sie können hier unten Ihr Angebot für eine{' '}
          {this.stringifyFuneralType(offer.funeralType)} annehmen.
        </p>
        <p>
          Hiermit möchte ich,{' '}
          <strong>
            {offer.contactDetails.firstName} {offer.contactDetails.lastName}
          </strong>
          , das Angebot <strong>{offer.orderId}</strong> zum Preis von{' '}
          <strong>
            <NumberFormat
              value={totalNoDiscount}
              displayType='text'
              thousandSeparator='.'
              decimalSeparator=','
              prefix='€ '
              decimalScale={2}
              fixedDecimalScale={!Number.isInteger(totalNoDiscount)}
            />
          </strong>{' '}
          (inkl. USt.) kosten&shy;pflichtig beauftragen.
        </p>
        <form style={{ padding: '0 5% 0 2.5%', marginBottom: 7.5 }}>
          <FormCheckbox
            value={checked1}
            onCheck={(check) => this.handleCheck('checked1', check)}>
            Ich bestätige, dass ich die{' '}
            <a href='/agb' target='_blank'>
              Allgemeinen Geschäfts&shy;bedingungen
            </a>
            , die{' '}
            <a href='/datenschutz' target='_blank'>
              Datenschutz&shy;erklärung
            </a>{' '}
            sowie die{' '}
            <a href='/widerruf' target='_blank'>
              Widerrufs&shy;belehrung
            </a>{' '}
            gelesen und akzeptiert habe.
          </FormCheckbox>
          <FormCheckbox
            value={checked2}
            onCheck={(check) => this.handleCheck('checked2', check)}>
            Ich wünsche, dass Benu mit der Bestattungs&shy;dienstleistung vor
            dem Ablauf der Widerrufsfrist beginnt.
          </FormCheckbox>
          <FormCheckbox
            value={checked3}
            onCheck={(check) => this.handleCheck('checked3', check)}>
            Ich bestätige, dass ich vom Verlust meines Widerrufsrechts bei
            vollständiger Vertrags&shy;erfüllung durch Benu vor Ablauf der
            Widerrufsfrist Kenntnis habe.
          </FormCheckbox>
          <FormCheckbox
            value={checked4}
            onCheck={(check) => this.handleCheck('checked4', check)}>
            Ich bestätige meine Kenntnis darüber, dass das vorliegende Angebot (
            {offer.orderId}) Kosten, die vor Überführung der verstorbenen Person
            durch Benu bereits angefallen sind sowie externe Gebühren
            (Verwaltungs&shy;gebühren, Friedhofs&shy;gebühren, etc.) nicht
            umfasst.
          </FormCheckbox>
        </form>
        <p>
          <strong>Zahlungsmethode</strong>
        </p>
        <RadioGroup style={{ marginBottom: 7.5 }}>
          <RadioButton
            name='payment'
            label='Kauf auf Rechnung'
            value='ON_APPROVAL'
            defaultChecked
            inline
            onClick={() => this.setPayment('ON_APPROVAL')}
          />
          <RadioButton
            name='payment'
            label='Vorkasse'
            value='PREPAY'
            inline
            onClick={() => this.setPayment('PREPAY')}
          />
        </RadioGroup>
        <Link
          disabled={!(checked1 && checked2 && checked3 && checked4)}
          onClick={this.submit}>
          Kostenpflichtig beauftragen
        </Link>
        <FeedbackText error>{errorMessage}</FeedbackText>
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-evenly'
          }}>
          <IconContainer>
            <Icon>
              <img src={heartIcon} alt='icon' />
            </Icon>
            <p>Einfühlsame & Kompetente Betreuung</p>
          </IconContainer>
          <IconContainer>
            <Icon>
              <img src={checkIcon} alt='icon' />
            </Icon>
            <p>Zuverlässige Organisation</p>
          </IconContainer>
          <IconContainer>
            <Icon>
              <img src={priceIcon} alt='icon' />
            </Icon>
            <p>Höchste Transparenz & faire Preise</p>
          </IconContainer>
        </div>
      </ConfiguratorBox>
    )
  }
}

const IconContainer = styled.div`
  display: inline-block;
  max-width: 210px;
  p {
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    line-height: 1.2;
    text-transform: uppercase;
    letter-spacing: 2px;
  }
`

const Icon = styled.div`
  width: 70px;
  height: 70px;
  margin: 7.5px auto;
  padding: 7.5px;
  img {
    width: 100%;
    margin: auto;
  }
`

export default withRouter(Order)



// WEBPACK FOOTER //
// ./src/components/organisms/checkout/Order.tsx